/* eslint-disable sonarjs/no-duplicate-string -- Icon map */
export const PROPERTY_NAMES = new Set([
  "leftContent",
  "rightContent",
  "buttons",
  "children",
  "content",
  "items",
  "header",
  "footer",
  "body",
]);

export const MAX_TREE_DEPTH = 100;

export const INVALID_DROP_I18N = "builder_ui.errors.invalid_element_drop";

export const BLOCK_TYPE_ICON_MAP: Record<string, string> = {
  // Layout
  section: "24-builder-element-section",
  container: "24-builder-element-container",
  stack: "24-builder-element-stack",
  grid: "24-builder-element-grid",

  // Text
  p: "24-builder-ui-element-paragraph",
  h1: "24-builder-ui-element-heading",
  h2: "24-builder-ui-element-heading",
  h3: "24-builder-ui-element-heading",
  h4: "24-builder-ui-element-heading",
  h5: "24-builder-ui-element-heading",
  h6: "24-builder-ui-element-heading",

  // Actions
  button: "24-builder-ui-element-button",
  primaryButton: "24-builder-ui-element-button",
  secondaryButton: "24-builder-ui-element-button",
  form: "24-builder-ui-element-contacts",
  link: "24-builder-ui-element-link",

  // Media
  embed: "24-builder-ui-element-embed-media",
  img: "24-builder-ui-element-image",
  video: "24-builder-ui-element-video",

  // Basic
  badge: "24-builder-ui-element-badge",
  badgeList: "24-builder-ui-element-badge-list",
  blockquote: "24-builder-ui-element-quote",
  code: "24-builder-ui-element-code",
  customHtml: "24-builder-ui-element-media-custom-html",
  horizontalLine: "24-horizontal-line",
  ul: "24-list",
} as const;

export const THREE_INDENTATION_WIDTH = 18;
